import { useContext } from 'react';
import { TranscriptTagsContext } from '@/containers/Transcript.Tagging/Context';

export const useTranscriptTagsContext = () => {
  return useContext(TranscriptTagsContext);
};